import { Button } from "@/components/ui/button";

interface KidQuickActionsProps {
  isBusy: boolean;
  isMoreOpen: boolean;
  onAdd30: () => void;
  onAdd60: () => void;
  onToggleMore: () => void;
}

export function KidQuickActions({ isBusy, isMoreOpen, onAdd30, onAdd60, onToggleMore }: KidQuickActionsProps) {
  return (
    <div className="grid gap-2 sm:grid-cols-3">
      <Button type="button" className="min-h-11" disabled={isBusy} onClick={onAdd30}>
        +30m
      </Button>
      <Button type="button" className="min-h-11" disabled={isBusy} onClick={onAdd60}>
        +60m
      </Button>
      <Button
        type="button"
        variant="outline"
        className="min-h-11"
        aria-expanded={isMoreOpen}
        onClick={onToggleMore}
      >
        {isMoreOpen ? "Hide actions" : "More actions"}
      </Button>
    </div>
  );
}
